import { render, staticRenderFns } from "./_detail.vue?vue&type=template&id=3feab7a5&"
import script from "./_detail.vue?vue&type=script&lang=js&"
export * from "./_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ConstructorLayout: require('/home/smiley/3df/components/Constructor/ConstructorLayout.vue').default,CardAuthor: require('/home/smiley/3df/components/Card/CardAuthor/CardAuthor.vue').default,Banner: require('/home/smiley/3df/components/Banner/Banner.vue').default,SectionRegister: require('/home/smiley/3df/components/Section/SectionRegister/SectionRegister.vue').default})
